module.exports = __webpack_public_path__ + "img/postcard-onboarding-example@1x.69335a2c.png";